import ActionsList from "core/actions/Actions.list";
import { actionCoreApi } from "core/utils/api";
import { actionErrorNotifier } from "core/utils/helpers";
import { dispatcherActionType } from "core/utils/interfaces";
import HTTPUrlHelper from "shared/helpers/HTTPUrlHelper";

export const fetchUserRoleById = (role_id: string, account?: string) =>
  actionErrorNotifier(actionCoreApi(
    ActionsList.FetchRole,
    account ? HTTPUrlHelper.getRoleByIdAndAccountAPI(role_id, account) :  HTTPUrlHelper.getRoleByIdAPI(role_id)
  ))

export const updateUserRole = (id, formData): dispatcherActionType => actionErrorNotifier(
  actionCoreApi(
    ActionsList.UpdateUserRole,
    HTTPUrlHelper.getRoleByIdAPI(id),
    'PUT',
    formData
  )
)